import React, { useState, useContext, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Spinner from 'react-bootstrap/Spinner';
import { isUserActive } from '../service/brc';
import { BrcContext } from '../BrcContextWrapper';
import { LOGIN_URL } from '../config/global';
import { useNavigate } from 'react-router-dom';
import "./Login.css";

export default function Login() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { sessionUser, setSessionUser } = useContext(BrcContext);

  useEffect(() => {
    const checkLoginStatus = async () => {
      if (sessionUser.email) {
        setLoading(false);
        return navigate('/');
      }
      try {
        setLoading(true);
        const userData = await isUserActive();
        setLoading(false);
        if (userData?.data.email) {
          setSessionUser(userData.data);
          navigate('/');
        }
      } catch (error) {
        console.error('Login Error', error);
      }

    };
    checkLoginStatus();
  }, [navigate, setSessionUser, sessionUser.email]);

  const handleSignIn = () => {
    window.location.href = LOGIN_URL;
  };

  return (

        <div className="Login">
          {!loading && <Button onClick={handleSignIn}>Sign In</Button>}
          {loading &&<Button size="lg" type="submit" disabled={true}>
            <Spinner
              as="span"
              animation="border"
              size="sm"
              role="status"
              aria-hidden="true"
            />
          </Button>}
      </div>

    );

}